import bookGameImage from '../assets/publications/Orion_concept.png'
import ieltsMetricsImage from '../assets/publications/Ielts_project.png'
import mentalWellnessImage from '../assets/publications/Emmy.png'
import figmaPluginImage from '../assets/publications/Figma_plugin.png'
import graphDatabaseImage from '../assets/publications/Architecture_for_graph.png'

export const publications = [
  {
    slug: 'book-game-emotional-worldbuilding',
    title: 'Interactive Storytelling and Game-Based Emotional Worldbuilding',
    type: 'Book / Game Concept',
    status: 'In Progress',
    image: bookGameImage,
    link: '',
    linkLabel: '',
    abstract:
      'A long-form writing project connected to a narrative game concept, exploring emotions, character development, symbolic environments, and interactive storytelling.',
    content: [
      'This work-in-progress book is connected to a game concept focused on emotions, memory, and personal growth. The project explores how storytelling, character design, and interactive environments can help users experience emotional themes through gameplay rather than direct explanation.',
      'The writing process includes worldbuilding, character psychology, visual atmosphere, narrative structure, and the relationship between player choices and emotional interpretation.',
      'From an academic perspective, the project connects to human-computer interaction, emotional design, game studies, and narrative systems. It also supports my interest in building software experiences that are not only functional, but also meaningful and human-centered.'
    ],
    topics: [
      'Interactive storytelling',
      'Game design',
      'Emotional design',
      'Narrative systems',
      'Human-computer interaction'
    ]
  },
  {
    slug: 'ielts-platform-learning-metrics',
    title: 'Designing Learning Metrics for an AI-Assisted IELTS Platform',
    type: 'Technical Article',
    status: 'Draft',
    image: ieltsMetricsImage,
    link: 'http://ielts-master.sbs/',
    linkLabel: 'Open IELTSMaster',
    abstract:
      'A technical note about building meaningful learning metrics for IELTS preparation, including progress tracking, writing feedback, speaking evaluation, and personalized recommendations.',
    content: [
      'This article explores how an IELTS preparation platform can use structured metrics to help students understand their progress across reading, writing, listening, and speaking modules.',
      'The project focuses on practical questions such as how to track answer accuracy, writing improvement, speaking fluency, grammar patterns, band-score estimation, and personalized learning recommendations.',
      'The goal is not only to display scores, but to design useful feedback loops that help learners understand what they should improve next. This connects to educational technology, AI-assisted feedback systems, and user-centered data visualization.'
    ],
    topics: [
      'Educational technology',
      'Learning analytics',
      'AI feedback',
      'IELTS preparation',
      'Progress tracking'
    ]
  },
  {
    slug: 'ai-mental-wellness-metrics',
    title: 'Metrics and Safety Design for AI-Assisted Mental Wellness Platforms',
    type: 'Research Note',
    status: 'In Progress',
    image: mentalWellnessImage,
    link: '',
    linkLabel: '',
    abstract:
      'A research-oriented note about emotional tracking, session summaries, responsible AI responses, tone control, and safer interface design for mental wellness tools.',
    content: [
      'This note studies how AI-assisted mental wellness platforms can be designed with careful attention to safety, tone, emotional tracking, and user trust.',
      'The project explores features such as mood history, session summaries, emotional trend charts, reflective prompts, user notes, and AI-generated insights. A key focus is making the system supportive without presenting it as a replacement for professional psychological care.',
      'The research direction connects to human-computer interaction, responsible AI, affective computing, and the design of emotionally sensitive software systems.'
    ],
    topics: [
      'Responsible AI',
      'Mental wellness',
      'Emotional tracking',
      'Human-computer interaction',
      'Safety design'
    ]
  },
  {
    slug: 'figma-plugin-development',
    title: 'Building Figma Plugins for AI-Assisted Design-to-Code Workflows',
    type: 'Technical Guide',
    status: 'Planned',
    image: figmaPluginImage,
    link: 'https://www.figma.com/plugin-docs/',
    linkLabel: 'Figma Plugin Docs',
    abstract:
      'A planned technical guide about creating Figma plugins, reading selected frames, extracting design data, and connecting plugin interfaces with AI-assisted code generation workflows.',
    content: [
      'This planned guide explains how to build Figma plugins that interact with selected frames, collect design information, and send structured data to a custom interface.',
      'The article will cover plugin architecture, communication between the Figma sandbox and UI layer, frame selection, design extraction, and possible integration with AI-assisted frontend generation.',
      'The goal is to document practical knowledge from experimenting with design-to-code workflows and to connect frontend engineering with UI/UX tooling.'
    ],
    topics: [
      'Figma plugins',
      'Design-to-code',
      'Frontend automation',
      'AI-assisted development',
      'UI/UX tooling'
    ]
  },
  {
    slug: 'graph-relational-knowledge-structuring',
    title: 'Graph and Relational Databases for Flexible Knowledge Structuring',
    type: 'Project Writeup',
    status: 'In Progress',
    image: graphDatabaseImage,
    link: '',
    linkLabel: '',
    abstract:
      'A project writeup about combining Neo4j and PostgreSQL for relationship-heavy data exploration, structured querying, and data visualization.',
    content: [
      'This project writeup explains the architecture behind ToStruct, a data visualization and structuring platform that combines graph and relational databases.',
      'The main idea is to use Neo4j for relationship-heavy data and PostgreSQL for structured relational storage. This allows the system to support flexible querying, entity relationships, and visual exploration of connected information.',
      'The writeup connects to database systems, information visualization, software architecture, and tools for organizing complex knowledge.'
    ],
    topics: [
      'Graph databases',
      'PostgreSQL',
      'Neo4j',
      'Data visualization',
      'Knowledge systems'
    ]
  }
]